import { ApexCodeHighlight } from '@periscopes/general/apex-classes';
import { ApexCodeHighlights } from '@sonar-software/sonar-ts-types';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { PeriscopeTablessContent } from '@periscopes/general';
import React from 'react';
import { useApiResource } from '@hooks';

export interface ApexTriggerCodeTabProps {
	index: number;
	sonarObjectId: number;
}

export const ApexTriggerCodeTab: React.FC<ApexTriggerCodeTabProps> = ({ index, sonarObjectId }) => {
	const targetUri = `v3/salesforce/apex-triggers/${sonarObjectId}/highlights`;
	const { resource, loading } = useApiResource<ApexCodeHighlights>(targetUri);

	if (loading) {
		return <LoadingSpinner spinning />;
	}

	const spans = resource?.spans ?? [];

	return (
		<PeriscopeTablessContent>
			<ApexCodeHighlight
				index={ index }
				spans={ spans } />
		</PeriscopeTablessContent>
	);
};
